import React from 'react';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
export function TopBar() {
  return <header className="w-full border-b border-white/10 bg-forest-deep" data-id="element-245" data-mp="232dql1n7rquv">
      <div className="mx-auto flex max-w-content items-center justify-between gap-4 px-5 py-3.5 lg:px-8" data-id="element-246" data-mp="2359mkkfi45go">
        <a href="#top" className="flex items-center gap-2.5" data-id="element-247" data-mp="1t4pjdc8f8qvt">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-gold font-display text-sm font-black text-forest-deep" data-id="element-248" data-mp="1t6aeb2ynebu7">
            FT
          </span>
          <span className="font-display text-base font-extrabold text-cream" data-id="element-249" data-mp="2lt4ydyrjz975">
            Full Tienda
          </span>
        </a>

        <div className="hidden items-center gap-6 text-xs font-medium text-cream/70 md:flex" data-id="element-250" data-mp="2h0tvqo5fh9aw">
          <span className="flex items-center gap-1.5" data-id="element-251" data-mp="2c322nqt1rh54">
            <ShieldCheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-252" data-mp="39jhcjrde6266" />
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-253" data-mp="34r7nedk3p64y">
            <LockIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-254" data-mp="257slyafktcp" />
            Pago seguro
          </span>
        </div>

        <a href="#comprar" className="rounded-md bg-gold px-4 py-2 font-display text-xs font-bold uppercase tracking-wide text-forest-deep transition-colors duration-150 ease-out hover:bg-gold-deep" data-id="element-255" data-mp="672t50kjf2pf">
          Quiero el sistema
        </a>
      </div>
    </header>;
}